import { clsx } from "clsx";
import type { ReactNode } from "react";
import { Heading, Text } from "../typography";

export interface SectionCardProps {
  title: ReactNode;
  subtitle?: string;
  action?: ReactNode;
  shadow?: boolean;
  className?: string;
  children: ReactNode;
}

export function SectionCard({
  title,
  subtitle,
  action,
  shadow = false,
  className,
  children,
}: SectionCardProps) {
  return (
    <div
      className={clsx(
        "flex flex-col rounded-2xl border border-borderDefault bg-bgWhite",
        shadow
          ? "gap-4 p-6 shadow-[0px_2px_12px_0px_rgba(190,189,217,0.2)] max-md:p-4"
          : "gap-4 px-6 py-5 max-md:px-4 max-md:py-4",
        className,
      )}
    >
      {action ? (
        // Phones: the action goes under the title instead of squeezing it.
        <div className="flex items-start justify-between max-md:flex-col max-md:gap-3">
          <div className="flex flex-col gap-2">
            <Heading variant="h3" tone="dark">{title}</Heading>
            {subtitle && <Text variant="bodySm" tone="body">{subtitle}</Text>}
          </div>
          {action}
        </div>
      ) : (
        <>
          <Heading variant="h3" tone="dark">{title}</Heading>
          {subtitle && <Text variant="bodySm" tone="body">{subtitle}</Text>}
        </>
      )}
      {children}
    </div>
  );
}
